"use client";
import { CopyOutlined } from "@ant-design/icons";
import { Button, Card, Col, Input, message, Space, Tooltip } from "antd";
import { useState } from "react";
import { adminApi } from "../../api";
import { useStorage } from "../../hooks";
import useClipboard from "../../utils";

function UrlToCdnCard() {
  const [url, setUrl] = useState<string>("");
  const { copy } = useClipboard();
  const [cdnHistory, setCdnHistory] = useStorage<string[]>("CDN_HISTORY", []);

  const urlConvert: React.MouseEventHandler<HTMLElement> = async () => {
    try {
      const response = await adminApi.get(
        `https://admin2.khanglobalstudies.com/studio/get-cdn-url?url=${url}`
      );
      message.success("URL Converted", 5);
      setCdnHistory([response.data.cdn, ...cdnHistory.slice(0, 9)]);
    } catch (error) {
      message.error(error.message || "Invalid URL", 10);
    }
  };
  return (
    <div>
      <Col xs={24} sm={24} md={24} lg={24} xl={12} xxl={12} className="mb-2">
        <Card title="URL to CDN Converter">
          <Space.Compact style={{ width: "100%" }}>
            <Input
              placeholder="Enter valid video url"
              value={url}
              onChange={(event) => setUrl(event.target.value)}
            />
            <Button loading={false} onClick={urlConvert} type="primary">
              Convert
            </Button>
          </Space.Compact>
          <div className="space-y-3">
            {cdnHistory.map((history, index) => (
              <div
                key={index}
                className="group flex mb-4 mt-6 items-center justify-between rounded-2xl border border-slate-200 bg-white px-4 py-3 transition-all duration-300 hover:border-slate-300 hover:shadow-sm"
              >
                <div className="min-w-0 flex-1">
                  <div className="mb-1 text-[11px] font-semibold uppercase tracking-wider text-slate-400">
                    CDN URL
                  </div>

                  <p className="truncate text-sm font-medium text-slate-700">
                    {history}
                  </p>
                </div>

                <Tooltip title="Copy URL">
                  <button
                    onClick={() => copy(history, "Url copied")}
                    className="ml-4 flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 bg-slate-50 text-slate-500 transition-all duration-300 hover:border-slate-300 hover:bg-slate-100 hover:text-slate-700"
                  >
                    <CopyOutlined />
                  </button>
                </Tooltip>
              </div>
            ))}
          </div>
        </Card>
      </Col>
    </div>
  );
}

export default UrlToCdnCard;
